export const getSplicedString = (value: string): string => {
  return value.slice(0, 8) + '...';
};
